/**
 * All coin gate blocks should be included here.
 *
 * @package WPCoinGate
 */
import './coin-gate-output';
